import Home from '../components/Main/Home'

let routes = {
    path: '/',
    component: resolve => require(['../components/layout/SingleFunctionPage'], resolve),
    children: [
      {
          path: '/',
          name: 'Home',
          component: Home
      },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/home.js